import type { GuideChapter } from '../types'
import { admin } from './admin'
import { basics } from './basics'
import { projects } from './projects'
import { service } from './service'
import { intranet } from './intranet'
import { stock } from './stock'

/**
 * Vejledningens kapitler i den rækkefølge, de vises (beslutning 089).
 *
 * Kommer der en ny funktion eller ændres en knaptekst, skal afsnittet her rettes med -
 * ellers passer vejledningen ikke længere til skærmen.
 */
export const guideChapters: GuideChapter[] = [basics, projects, service, stock, intranet, admin]
